import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
function DecapTile({
  size = '32'
}) {
  return ___EmotionJSX("svg", {
    width: size,
    height: size,
    viewBox: "0 0 72 72",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "Decap logomark"
  }, ___EmotionJSX("path", {
    d: "M71.1198 71.1244V0.012475C71.1198 0.012475 0 -0.0020714 0 0.0067415V71.1244H71.1198Z",
    fill: "#FF0082"
  }), ___EmotionJSX("path", {
    d: "M27.6894 10.6367L10.582 12.2001L12.6258 34.5807L23.7743 33.565L22.6662 21.3961L28.6251 20.8544C34.5287 20.3189 39.275 25.0462 39.9213 32.0939L50.8666 31.0968C49.7401 18.7555 39.3304 9.59031 27.6956 10.6429L27.6894 10.6367Z",
    fill: "white"
  }), ___EmotionJSX("path", {
    d: "M51.5562 38.1142C51.5562 45.1927 47.2532 50.3324 41.3311 50.3324H35.3475V38.0957H24.156V60.587H41.3311C53.0336 60.587 62.5507 50.5047 62.5507 38.1142C62.5507 38.108 62.5507 38.1019 62.5507 38.0957H51.5562C51.5562 38.0957 51.5562 38.108 51.5562 38.1142Z",
    fill: "white"
  }));
}
export default DecapTile;